// TODO LL22-XXXX Use core/ui once we fix translations
import { Attribution as A } from "@local-logic/elements-react";
// import { Attribution as A } from "@local-logic/core/ui";
import React from "react";
import * as styles from "./styles";

interface AttributionProps {
  attributionClicked?: () => void;
}

const Attribution = ({ attributionClicked }: AttributionProps) => (
  <div className={styles.container} onClick={attributionClicked}>
    <A.Root />
  </div>
);

export default Attribution;
